import type { ChinaEnvironment } from '@susu/custom-made/utils/constants';
import { typeEnvironments } from '@susu/custom-made/utils/interfaces';
import { createContext } from 'react';

type EnvironmentContextType = {
  env: typeEnvironments | ChinaEnvironment;
  datadogClientToken: string;
  datadogApplicationId: string;
  scanditKey: string;
  configuratordataproviderBasePath: string;
  productconfigurationBasePath: string;
  productmeasurementBasePath: string;
  addToCartWebstoreUrlTemplate: string;
  configurationImagesBasePath: string;
  createconfiguredproductimagePath: string;
  cacheBasePath: string;
  bookingToolServiceId: string;
  cdnDomain: string;
  cmWebstoreOrigin: string;
  datadogAppVersion: string;
  datadogSessionSampleRate: number;
  datadogSessionReplaySampleRate: number;
  datadogLogsSampleRate: number;
};

const defaultEnvironmentContext: EnvironmentContextType = {
  env: 'dev',
  datadogClientToken: '',
  datadogApplicationId: '',
  scanditKey: '',
  configuratordataproviderBasePath: '',
  productconfigurationBasePath: '',
  productmeasurementBasePath: '',
  addToCartWebstoreUrlTemplate: '',
  configurationImagesBasePath: '',
  createconfiguredproductimagePath: '',
  cacheBasePath: '',
  bookingToolServiceId: '',
  cdnDomain: '',
  cmWebstoreOrigin: '',
  datadogAppVersion: '',
  datadogSessionSampleRate: 5,
  datadogSessionReplaySampleRate: 5,
  datadogLogsSampleRate: 5,
};

export const EnvironmentContext = createContext<EnvironmentContextType>(defaultEnvironmentContext);
